import { Component, Host, Prop, h } from '@stencil/core'

@Component({
  tag: 'cobalt-notification-pill',
  styleUrl: 'cobalt-notification-pill.css'
})
export class CobaltNotificationPill {
  @Prop({ mutable: true }) number?: string = undefined

  render(): any {
    return (
      <Host class="cobalt-notification-pill" role="status">
        <core-notification-pill number={this.number}></core-notification-pill>
      </Host>
    )
  }
}
